// extracted by mini-css-extract-plugin
export default {"input":"Bca-z","button":"Cca-z","selected":"Dca-z","unavailable":"Eca-z","oos":"Fca-z","paperCutDisabledOverlay":"Gca-z","image":"Hca-z"};